import { Injectable } from '@angular/core';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class ServiceChangeRequestService {

    constructor(private dataService: DataService) { }

    save(upgradeRequestDetails: any) {
        return this.dataService.post('/api/ServiceChangeRequest/ServiceChangeRequest', upgradeRequestDetails);
    }

    saveCommentsForAcknowledgement(upgradeRequestDetails: any) {
        return this.dataService.post('/api/ServiceChangeRequest/saveCommentsForAcknowledgement', upgradeRequestDetails);
    }

    getAcknowledgedComments(serviceChangeRequestId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getAcknowledgedComments/?serviceChangeRequestId=' + serviceChangeRequestId);
    }

    getServiceChangeRequests(searchQuery: any) {
        return this.dataService.getRecordWithParams('/api/ServiceChangeRequest/GetServiceChangeRequest/', searchQuery);
    }

    getServiceCancelRequests(searchQuery: any) {
        return this.dataService.getRecordWithParams('/api/ServiceChangeRequest/GetServiceCancelRequest/', searchQuery);
    }

    getUserNamesTerminationByUserId(userid: number) {

        return this.dataService.getRecord('/api/Connection/GetUserNamesTerminationByUserId/?UserId=' + userid);
    }

    getServiceChangeRequestByConnectionId(connectionId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/GetServiceChangeRequestByConnectionId/?connectionId=' + connectionId);
    }

    getAddressChangeApplicationByConnectionId(connectionId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/getAddressChangeApplicationByConnectionId/?connectionId=' + connectionId);
    }

    getReturnRouterDetailsByApplicationId(applicationId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/getReturnRouterDetailsByApplicationId/?applicationId=' + applicationId);
    }

    terminateNow(terminateNow) {

        return this.dataService.post('/api/ServiceChangeRequest/TerminateNow', terminateNow);
    }
    checkAnyServiceChangeOrCancel(applicationId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/CheckAnyServiceChangeOrCancel/?applicationId=' + applicationId);
    }
    terminateWithNotice(terminateWithNotice: any) {
        return this.dataService.post('/api/ServiceChangeRequest/TerminateWithNotice', terminateWithNotice);
    }
    getServiceChangeRequestUpandDowngradeByConnectionId(connectionId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/GetServiceChangeRequestUpandDowngradeByConnectionId/?connectionId=' + connectionId);
    }
    serviceChangeRequestById(changeReqId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/ServiceChangeRequestById/?changeReqId=' + changeReqId);
    }
    getUserAllowToSelectConnection(connectionId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/GetUserAllowToSelectConnection/?connectionId=' + connectionId);
    }
    getServiceCancellationHistory(applicationId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getServiceCancellationHistory/' + applicationId);
    }
    getServiceChangeHistory(applicationId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getServiceChangeHistory/' + applicationId);
    }
    getServiceProviderIdByKey(serviceProviderId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getServiceProviderIdByKey/' + serviceProviderId);
    }
    getAdvancedSearchForCancellation(searchQuery, refresh) {
        return this.dataService.getDataWithParams('/api/ServiceChangeRequest/getAdvancedApplicationsSearchForCancellation', searchQuery, refresh);
    };

    getUltimateTerminationFee(searchQuery: any) {
        return this.dataService.post('/api/ServiceChangeRequest/getUltimateTerminationFee', searchQuery);
    };

    getUltimateTerminationFeeFromAdmin(searchQuery: any) {
        return this.dataService.post('/api/ServiceChangeRequest/getUltimateTerminationFeeFromAdmin', searchQuery);
    };

    getAdvancedSearchForServiceChange(searchQuery, refresh) {
        return this.dataService.getDataWithParams('/api/ServiceChangeRequest/getAdvancedApplicationsSearchForServiceChange', searchQuery, refresh);
    };

    getConnectionIsWANCreditCardCompleted(connectionId: number) {

        return this.dataService.getRecord('/api/ServiceChangeRequest/getConnectionIsWANCreditCardCompleted/?connectionId=' + connectionId);
    }

    getTerminationFeeCalculation(searchQuery: any) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getTerminationFeeCalculation/?referenceNumber=' + searchQuery);
    };

    ServiceChangeMailToServiceProvider(serviceProviderEmail: any) {
        return this.dataService.post('/api/NotificationMessageInfo/ServiceChangeMailToServiceProvider', serviceProviderEmail);
    };

    CancellationOfServiceMailToServiceProvider(serviceProviderEmail: any) {
        return this.dataService.post('/api/NotificationMessageInfo/CancellationMailToServiceProvider', serviceProviderEmail);
    };

    moveToCancellationCompleted(moveToCancellation) {
        return this.dataService.post('/api/ServiceChangeRequest/MoveToCancellationCompleted', moveToCancellation);
    };

    getServiceCancelRequestOnLoading(searchQuery, refresh) {

        return this.dataService.getDataWithParams('/api/ServiceChangeRequest/getServiceCancelRequestOnLoading', searchQuery, refresh);
    };
    getServiceChangRequestOnLoading(refresh) {

        return this.dataService.getRecordWithParams('/api/ServiceChangeRequest/getServiceChangRequestOnLoading', refresh);
    }

    getServiceChangeRequestSearchView(searchQuery, refresh) {
        return this.dataService.getDataWithParams('/api/ServiceChangeRequest/GetServiceChangeRequestSearchView/', searchQuery, refresh);
    }

    getThreeMonthTerminationFee(searchQuery: any) {
        return this.dataService.post('/api/ServiceChangeRequest/getThreeMonthTerminationFee', searchQuery);
    };

    getIsshoppingOrders(applicationId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getIsshoppingOrders/?applicationId=' + applicationId);
    }
    ChangeOrderLineItem(UserId: number, Datetime) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/ChangeOrderLineItem/?UserId=' + UserId + '&CancelProductDateTs=' + Datetime);
    }
    CancelOrderLineItem(applicationId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/CancelOrderLineItem/?applicationId=' + applicationId);
    }
    EnableOrderlineItems(applicationId: number) {
        return this.dataService.getRecord('/api/ServiceChangeRequest/EnableOrderlineItems/?applicationId=' + applicationId);
    }
    getFrogfootTerminationReasons() {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getFrogfootTerminationReasons');
    }

    getVumetalTerminationReasons() {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getVumetalTerminationReasons');
    }

    getRetentionPromotionPricing(applicationId: number) {
        return this.dataService.getRecord('/api/RetentionPromotion/getRetentionPromotionPricing/?applicationId=' + applicationId);

    }
    CheckRetentionPromoIsApplicable(applicationId: number) {
        return this.dataService.getRecord('/api/RetentionPromotion/checkRetentionPromoIsApplicable/?applicationId=' + applicationId);

    }
    getUserEmailsForAddingRetentionPromo() {
        return this.dataService.getRecord('/api/RetentionPromotion/getUserEmailsForAddingRetentionPromo');

    }

    generateLinkRetentionPromotion(customerReferenceNumber) {
        return this.dataService.getRecord('/api/RetentionPromotion/GenerateLinkForRellocaltionLogin/?customerReferenceNumber=' + customerReferenceNumber);

    }

}
